import { render, staticRenderFns } from "./IlluManagementEnseignants.vue?vue&type=template&id=38b488c0&"
import script from "./IlluManagementEnseignants.vue?vue&type=script&lang=js&"
export * from "./IlluManagementEnseignants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports